<app-banner [title]="'Dossier patient'" [links]="links"></app-banner>

<div class="container">
	<div class="flex gap-4 mt-5 pb-12">
		<div class="min-w-[330px] sticky top-[150px] bg-white shadow rounded-lg p-4 h-[60vh] hidden lg:block">
			<h4 class="!text-[12px] font-medium text-gray-400">Dossier patient</h4>

			<div class="space-y-3 mt-4">
				@for (menu of medicalRecordMenu; track menu.key) {
				<div class="flex items-center gap-3 cursor-pointer rounded p-3"
					[class.text-white]="selectedMenu.key === menu.key"
					[class.bg-primary]="selectedMenu.key === menu.key" (click)="selectedMenu = menu">
					<lucide-icon [img]="menu.icon" class="" [size]="24"></lucide-icon>
					<span class="text-sm font-medium">{{ menu.label }}</span>
				</div>
				}
			</div>
		</div>
		<div class="bg-white w-full p-2 md:p-4 shadow rounded-lg relative">
			<div class="flex items-center justify-between gap-3">
				<div class="flex-1 flex flex-col lg:items-center justify-between gap-3 lg:flex-row">
					<h5 class="!text-[12px] font-medium text-gray-400 uppercase">{{ selectedMenu.label }}</h5>
					<button *ngIf="selectedMenu.key === 'administrative_data' || selectedMenu.key === 'medical_record'"
						type="button" (click)="onDownloadPrint(selectedMenu.key)" [disabled]="exportLoading"
						class="w-fit btn btn-primary btn-sm gap-2">
						@if (exportLoading) {
						<span
							class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
						<span>Téléchargement…</span>
						} @else {
						<lucide-icon [img]="DownloadIcon" [size]="16"></lucide-icon>
						<span>Télécharger</span>
						}
					</button>
				</div>
				<div class="relative" #menuRoot>
					<div class="flex items-center gap-2">
						<button type="button" class="lg:hidden" (click)="toggleMenu()">
							<lucide-icon [img]="Menu" class="" [size]="21"></lucide-icon>
						</button>
					</div>
					<div class="space-y-3 absolute top-0 right-0 z-20 shadow w-[300px] bg-white p-4"
						[class.hidden]="!isMenuOpen">
						<button type="button" (click)="toggleMenu()">
							<lucide-icon [img]="CloseIcon" class="" [size]="21"></lucide-icon>
						</button>
						@for (menu of medicalRecordMenu; track menu.key) {
						<div class="flex items-center gap-3 cursor-pointer rounded p-3"
							[class.text-white]="selectedMenu.key === menu.key"
							[class.bg-primary]="selectedMenu.key === menu.key"
							(click)="selectedMenu = menu; isMenuOpen = false">
							<lucide-icon [img]="menu.icon" class="" [size]="24"></lucide-icon>
							<span class="text-sm font-medium">{{ menu.label }}</span>
						</div>
						}
					</div>
				</div>
			</div>
			<div class="mt-4">
				@switch (selectedMenu.key) {
				@case ('administrative_data') {

				<!-- name of each tab group should be unique -->
				<div class="tabs tabs-lift bg-white rounded-lg">
					<label class="tab !bg-white !border-gray-200">
						<input type="radio" checked="checked" name="my_tabs_4" />
						Identité du patient
					</label>
					<div class="tab-content p-2 md:p-6">
						<app-administrative-data></app-administrative-data>
					</div>

					<label class="tab !bg-white !border-gray-200">
						<input type="radio" name="my_tabs_4" />
						Contacts/Filiation
					</label>
					<div class="tab-content p-6">
						<app-contacts-and-filiation></app-contacts-and-filiation>
					</div>
				</div>

				}
				@case ('medical_record') {
				<app-medical-record></app-medical-record>
				}
				@case ('documents') {
				<app-documents [beneficiaries]="documentsBeneficiaries" [showAddButton]="true">
				</app-documents>
				}
				@case ('medical_history') {
				<app-medical-history [beneficiaries]="medicalHistoryBeneficiaries"></app-medical-history>
				}
				}
			</div>
		</div>
	</div>
</div>